export function assetsHasErrored(state = false, action) {
    switch (action.type) {
        case 'ASSETS_HAS_ERRORED':
            return action.hasErrored;

        default:
            return state;
    }
}

export function assetsIsLoading(state = false, action) {
    switch (action.type) {
        case 'ASSETS_IS_LOADING':
            return action.isLoading;

        default:
            return state;
    }
}

export function assetsIsLoaded(state = false, action) {
    switch (action.type) {
        case 'ASSETS_IS_LOADED':
            return action.isLoaded;

        default:
            return state;
    }
}

export function assets(state = [], action) {
    switch (action.type) {
        case 'ASSETS_FETCH_DATA_SUCCESS':
            return action.assets;

        default:
            return state;
    }
}

export function preloadingDone(state = false, action) {
    switch (action.type) {
        case 'PRELOADING_DONE':
            return action.payload;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/assets.js